






































































































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import {
  ReviewRatingSeminar,
  ReviewRatingIntern,
  ReviewRatingRecruitment,
  Genre
} from "@/components/Pages/CompanyDetail/types";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import Badge from "@/components/Atoms/Badge/index.vue";
import Rates from "@/components/Molecules/Rates/index.vue";
import SpeechBubble from "@/components/Atoms/SpeechBubble/index.vue";
import { CompanyDetailReviewCategory } from "@/api/types";
import { CATEGORY_NAME } from "@/constants/company";
import { isNotNullOrUndefined } from "@/helpers/type-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ReviewCard",
  components: {
    Body,
    Heading,
    Suffix,
    Badge,
    Rates,
    SpeechBubble
  },
  props: {
    genre: {
      type: String as PropType<Props["genre"]>,
      required: true
    },
    category: {
      type: String as PropType<Props["category"]>,
      required: true
    },
    reviewData: {
      type: Object as PropType<Props["reviewData"]>,
      required: true
    }
  },
  data() {
    return {
      reviewCategory: CompanyDetailReviewCategory,
      hoverRating: false
    };
  },
  computed: {
    reviewText() {
      switch (this.genre) {
        case "rating1":
          return this.textFormat(1);
        case "rating2":
          return this.textFormat(2);
        case "rating3":
          return this.textFormat(3);
        case "rating4":
          return this.textFormat(4);
        case "rating5":
          return this.textFormat(5);
        case "rating6":
          return this.textFormat(6);
        default:
          return `
            ${this.textFormat(1)}
            ${this.textFormat(2)}
            ${this.textFormat(3)}
            ${this.textFormat(4)}
            ${this.textFormat(5)}
            ${this.textFormat(6)}
          `;
      }
    },
    metaInfos() {
      // NOTE: 表示する項目を並び替え + 情報の絞り込み
      const displayReviewDataInfo: Props["reviewData"]["info"] = {
        occupation: this.reviewData.info.occupation,
        graduate_year: this.reviewData.info.graduate_year,
        contract: this.reviewData.info.contract,
        schedule: this.reviewData.info.schedule,
        location: this.reviewData.info.location,
        period: this.reviewData.info.period,
        format: this.reviewData.info.format,
        offer_season: this.reviewData.info.offer_season,
        result: this.reviewData.info.result
      };

      switch (this.category) {
        case this.reviewCategory.SEMINAR: {
          const {
            occupation,
            graduate_year,
            location,
            season,
            ...other
          } = displayReviewDataInfo;

          return {
            main: [occupation, `${graduate_year}年卒`, location].filter(
              isNotNullOrUndefined
            ),
            sub: Object.values(other).filter(isNotNullOrUndefined)
          };
        }

        case this.reviewCategory.INTERN: {
          const {
            occupation,
            graduate_year,
            season,
            ...other
          } = displayReviewDataInfo;

          return {
            main: [occupation, `${graduate_year}年卒`].filter(
              isNotNullOrUndefined
            ),
            sub: Object.values(other).filter(isNotNullOrUndefined)
          };
        }

        case this.reviewCategory.RECRUITMENT: {
          const {
            occupation,
            graduate_year,
            contract,
            season,
            ...other
          } = displayReviewDataInfo;

          return {
            main: [occupation, `${graduate_year}年卒`, contract].filter(
              isNotNullOrUndefined
            ),
            sub: Object.values(other).filter(isNotNullOrUndefined)
          };
        }

        default:
          return { main: [], sub: [] };
      }
    }
  },
  methods: {
    textFormat(index) {
      return `
        【${this.genreLabel(`rating${index}` as Genre)}：
        ${Number(this.reviewData.review[`rating${index}`]).toFixed(1)}】
        ${this.reviewData.review[`detail${index}`]}
      `;
    },
    onMouseoverRating() {
      this.hoverRating = true;
    },
    onMouseleaveRating() {
      this.hoverRating = false;
    },
    genreLabel(genre) {
      const label = "の評価";
      switch (this.category) {
        case CompanyDetailReviewCategory.SEMINAR:
          ReviewRatingSeminar["rating_ave"] =
            CATEGORY_NAME[CompanyDetailReviewCategory.SEMINAR] + label;
          return ReviewRatingSeminar[genre];
        case CompanyDetailReviewCategory.INTERN:
          ReviewRatingIntern["rating_ave"] =
            CATEGORY_NAME[CompanyDetailReviewCategory.INTERN] + label;
          return ReviewRatingIntern[genre];
        case CompanyDetailReviewCategory.RECRUITMENT:
          ReviewRatingRecruitment["rating_ave"] =
            CATEGORY_NAME[CompanyDetailReviewCategory.RECRUITMENT] + label;
          return ReviewRatingRecruitment[genre];
        // TODO: ENTRY_SHEET の項目は今後対応
        // case CompanyDetailReviewCategory.ENTRY_SHEET:
        //   ReviewRatingRecruitment["rating_ave"] =
        //     CATEGORY_NAME[CompanyDetailReviewCategory.ENTRY_SHEET] + label;
        //   return ReviewRatingRecruitment[genre];
      }
    },
    eventExperienceUrl(id) {
      return this.$router.resolve({
        name: "EventExperience",
        params: {
          eventExperienceId: String(id)
        }
      }).href;
    }
  }
});
